import type { ReactNode } from '@tanstack/react-router';

interface PublicLayoutProps {
	children: ReactNode;
}

export const PublicLayout: React.FC<PublicLayoutProps> = ({ children }) => {
	return (
		<div className="flex h-screen flex-row">
			<div className="my-auto flex-1 shrink lg:my-0 lg:grid lg:place-content-center">
				<div className="p-xl lg:p-6xl mx-4 flex flex-col justify-center gap-4 lg:min-w-[424px]">{children}</div>
			</div>
			<div className="hidden flex-1 shrink bg-[url(/images/login.jpeg)] bg-cover bg-center lg:block"></div>
		</div>
	);
};
